<!-- 暂无匹配产品页面 -->
<template>
  <div class="results-empty">
    <div class="results-empty-content">
      <!-- 空状态插画 -->
      <div class="results-empty-illustration">
        <img src="../../assets/images/empty.png" alt="暂无匹配产品" />
      </div>

      <div class="results-empty-title">暂无匹配产品</div>
    </div>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
export default {
  name: 'ResultsEmpty',
  created() {
    window.__TRACK_SCENE_KEY__ = 'resultsEmpty'
  },
  mounted() {
    API_Common.handleBatchTrackBase('10063')
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
</script>

<style lang="scss" scoped>
.results-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(180deg, #fdfaf7 0%, #f9f6f2 100%);
  padding: 0 0.4rem;
}

.results-empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.results-empty-illustration {
  margin-bottom: 0.6rem;
  img {
    width: 240px;
    height: auto;
    max-width: 80vw;
  }
}

.results-empty-title {
  font-size: 0.36rem;
  color: #666;
  font-weight: 400;
  letter-spacing: 0.02em;
}
</style>
